import Service from "../../Services";

const SponserProgram = {
  namespaced : true,
  state : {
    form : {
      branch_id : '',
      title_th : '',
      title_en : '',
      description_en : '',
      description_th : '',
      orders : '',
      is_publish : true,
    }
  },
  mutations : {
    GET_FORM:(state,res)=>{
      state.form = res;
    },
    CLEAR_FORM_DATA :(state)=>{
      state.form = {
        branch_id : '',
        title_th : '',
        title_en : '',
        description_en : '',
        description_th : '',
        orders : '',
        is_publish : true,
      }
    }
  },
  actions : {
    getSponserProgram({commit},page){
      return Service.SponserProgramAPI.getSponserProgram(page);
    },
    showSponserProgram({commit},id){
      return Service.SponserProgramAPI.showSponserProgram(id);
    },
    saveSponserProgram({commit},{id,data}){
      if(id){
        return Service.SponserProgramAPI.updateSponserProgram(id,data);
      }else{
        return Service.SponserProgramAPI.createSponserProgram(data);
      }
    },
    deleteSponserProgram({commit},id){
      return Service.SponserProgramAPI.deleteSponserProgram(id);
    },
    setFormSponserProgram({commit},res){
      commit('GET_FORM',res);
    },
    clearFormData({commit}){
      commit('CLEAR_FORM_DATA');
    }
  },
}
export default SponserProgram
